export const SET_DISCOUNTS = 'SET_DISCOUNTS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const CREATE_DISCOUNT = 'CREATE_DISCOUNT';
export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNT';
export const DEL_DISCOUNT = 'DEL_DISCOUNT';